export default __webpack_public_path__ + "static/knit3-36ec31aab6e50fb0aa45ae45426092e4.jpg";